// extracted by mini-css-extract-plugin
export default {"AdditionalInfoContainer":"AuthForm_AdditionalInfoContainer__a13Wp","Link":"AuthForm_Link__cJ7wA","FormContainerButton":"AuthForm_FormContainerButton__0e80B"};